<template>
	<v-card>
		<v-card-title>
			<v-spacer />
			<v-spacer />
			<v-text-field
				v-model="lookingFor"
				append-icon="mdi-magnify"
				label="חיפוש"
				single-line
				hide-details
			/>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="clients"
			:loading="loading"
			class="elevation-1"
			:search="lookingFor"
		>
			<v-progress-linear
				slot="progress"
				color="blue"
				indeterminate
			/>
			<template #item.action="{item}">
				<action-td
					:item="item"
					module="authclient"
					@edit="onEdit(item)"
				/>
			</template>
		</v-data-table>
	</v-card>
</template>
<script>
import { types } from "src/store/modules/Passport.module";
import ActionTd from "src/components/AcationTd";
import FilterAble from "../../mixins/FilterAble";

export default {
	name: "PassportsTable",
	components: {
		ActionTd,
	},
	mixins: [new FilterAble(types)],
	props: {},
	data () {
		return {
			loading: false,
			headers: [
				{ text: "מזהה", value: "id" },
				{ text: "name", value: "name" },
				{ text: "secret", value: "secret" },
				{ text: "redirect", value: "redirect" },
				{ text: "action", value: "action" },
			],
			lookingFor: null,
			showDialog: false,
		};
	},
	computed: {
		clients () {
			return this.$store.state.PassportModule.authclients;
		},
	},
	methods: {
		onEdit (passport) {
			this.$emit("edit", passport);
		},
	},
};
</script>

							<style scoped>

							</style>
